import {
  PersonalScheduleStateTypes,
  PersonalScheduleActionTypes,
} from "./PersonalSchedule.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: PersonalScheduleStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const PersonalScheduleReducer = (
  state: PersonalScheduleStateTypes = INITIAL_STATE,
  action: any
): PersonalScheduleStateTypes => {
  switch (action.type) {
    case PersonalScheduleActionTypes.FETCH_ALL_PERSONAL_SCHEDULE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case PersonalScheduleActionTypes.FETCH_ALL_PERSONAL_SCHEDULE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PersonalScheduleActionTypes.FETCH_ALL_PERSONAL_SCHEDULE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PersonalScheduleActionTypes.FETCH_ALL_PERSONAL_SCHEDULE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case PersonalScheduleActionTypes.FETCH_ONE_PERSONAL_SCHEDULE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case PersonalScheduleActionTypes.FETCH_ONE_PERSONAL_SCHEDULE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case PersonalScheduleActionTypes.FETCH_ONE_PERSONAL_SCHEDULE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PersonalScheduleActionTypes.FETCH_ONE_PERSONAL_SCHEDULE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default PersonalScheduleReducer;
